import { FilterSelectionType } from 'shared/types/graphql';
import { defaultChannelListFilter, IChannelListFilter } from './IChannelListFilter';

export interface IChannelListFilterSelection {
  id?: string;
  name: string;
  isDeleted: boolean;
  filterSelectionType: FilterSelectionType;
  filters: IChannelListFilter;
}

export const defaultChannelListFilterSelection: IChannelListFilterSelection = {
  id: '',
  name: '',
  isDeleted: false,
  filterSelectionType: FilterSelectionType.PublicReadonly,
  filters: defaultChannelListFilter,
};
